import { createFilterStore } from './createFilterStore';

export const useEmployeeFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  status: '',
  employmentType: '',
  department: '',
  sortBy: 'employeeCode',
  sortOrder: 'asc' as const,
});
